import script from "./OfferTimerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferTimerComponent.vue?vue&type=script&setup=true&lang=js"

import "./OfferTimerComponent.vue?vue&type=style&index=0&id=0a4ee607&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4ee607"]])

export default __exports__